import { type JSONObject, Temporal } from '@imago/api-client'
import { type Stripe_InvoiceID } from '@imago/api-client-stripe'

export type InvoiceID = Stripe_InvoiceID

export interface InvoiceInfo {
	ID: Stripe_InvoiceID
	number: string
	periodStart: Temporal.Instant
	periodEnd: Temporal.Instant
	amountRemaining: number
	dueBy: Temporal.Instant
	nextAttemptOn: Temporal.Instant | null
}

export interface InvoiceInfoJSON extends JSONObject {
	ID: Stripe_InvoiceID
	number: string
	periodStart: Temporal.Instant_ISO
	periodEnd: Temporal.Instant_ISO
	amountRemaining: number
	dueBy: Temporal.Instant_ISO
	nextAttemptOn: Temporal.Instant_ISO | null
}

export function serializeInvoiceInfo(invoice: InvoiceInfo): InvoiceInfoJSON {
	return {
		...invoice,
		periodStart: invoice.periodStart.toString(),
		periodEnd: invoice.periodEnd.toString(),
		dueBy: invoice.dueBy.toString(),
		nextAttemptOn: invoice.nextAttemptOn === null ? null : invoice.nextAttemptOn.toString()
	}
}

export function deserializeInvoiceInfo(invoice: InvoiceInfoJSON): InvoiceInfo {
	return {
		...invoice,
		periodStart: Temporal.Instant.from(invoice.periodStart),
		periodEnd: Temporal.Instant.from(invoice.periodEnd),
		dueBy: Temporal.Instant.from(invoice.dueBy),
		nextAttemptOn: invoice.nextAttemptOn === null ? null : Temporal.Instant.from(invoice.nextAttemptOn),
	}
}
